import { Grid } from '@mui/material'
import { FC, isValidElement, PropsWithChildren, ReactNode } from 'react'

interface GridColumnProps extends PropsWithChildren {
  col: number
  shouldShowBackground?: boolean
  noBorderForItems?: number[]
  noBackgroundForItems?: number[]
}

export const GridColumn: FC<GridColumnProps> = ({ children, col, shouldShowBackground, noBorderForItems = [], noBackgroundForItems = [] }) => {
  const shouldApplyBorder = (index: number, child: ReactNode): boolean => {
    if (noBorderForItems.includes(index)) return false

    if (isValidElement(child)) {
      const props = child.props as Record<string, unknown>
      if ('data-noborder' in props) return false
    }

    return true
  }

  const shouldApplyBackground = (index: number, child: ReactNode): boolean => {
    if (!shouldShowBackground) return false
    if (noBackgroundForItems.includes(index)) return false

    if (isValidElement(child)) {
      const props = child.props as Record<string, unknown>
      if ('data-nobackground' in props) return false
    }

    return true
  }

  return (
    <>
      {children && Array.isArray(children)
        ? children.map((child, index) => (
            <Grid
              key={index}
              sx={{
                gridColumnStart: col,
                gridColumnEnd: col + 1,
                gridRowStart: index,
                gridRowEnd: index + 1,
                borderBottom: shouldApplyBorder(index, child) ? '1px solid var(--border-medium)' : 'none',
                backgroundColor: shouldApplyBackground(index, child) ? 'var(--bg-cell-error)' : 'transparent',
                display: 'flex',
                alignItems: 'flex-end'
              }}
            >
              {child}
            </Grid>
          ))
        : null}
    </>
  )
}
